import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../api";
import StatusBadge from "../components/StatusBadge";

export default function Rentals() {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("active");
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("q") || "");

  useEffect(() => {
    if (search) setSearchParams({ q: search }, { replace: true });
    else if (searchParams.get("q")) setSearchParams({}, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    setLoading(true);
    api
      .listRentals(filter === "all" ? {} : { status: filter })
      .then(setRentals)
      .finally(() => setLoading(false));
  }, [filter]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rentals;
    return rentals.filter((r) =>
      [r.rental_id, r.first_name, r.last_name, r.customer_email]
        .filter(Boolean)
        .some((s) => s.toLowerCase().includes(q)),
    );
  }, [rentals, search]);

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl">Verleihe</h1>
          <p className="text-fh-gray text-sm mt-1">{filtered.length} Einträge</p>
        </div>
        <Link to="/rental/new" className="btn-secondary">+ Manuell anlegen</Link>
      </div>

      <div className="flex flex-wrap gap-2">
        {[
          { v: "active", l: "Aktiv" },
          { v: "returned", l: "Zurück" },
          { v: "all", l: "Alle" },
        ].map((opt) => (
          <button
            key={opt.v}
            onClick={() => setFilter(opt.v)}
            className={[
              "px-3 py-1.5 rounded-md text-sm font-medium transition-colors",
              filter === opt.v ? "bg-fh-black text-white" : "bg-white border border-gray-300 hover:bg-fh-gray-light",
            ].join(" ")}
          >
            {opt.l}
          </button>
        ))}
        <input
          type="search"
          placeholder="Suche nach Name, ID, Email…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="input-field max-w-sm flex-1 ml-auto"
        />
      </div>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-fh-gray">Lade…</div>
        ) : filtered.length === 0 ? (
          <div className="p-8 text-center text-fh-gray">Keine Verleihe gefunden.</div>
        ) : (
          <ul className="divide-y divide-gray-100">
            {filtered.map((r) => (
              <li key={r.rental_id}>
                <Link
                  to={`/rentals/${r.rental_id}`}
                  className="flex items-center gap-4 px-5 py-3 hover:bg-fh-gray-light transition-colors"
                >
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-medium truncate">{r.first_name} {r.last_name}</span>
                      <StatusBadge status={r.status} />
                    </div>
                    <div className="text-xs text-fh-gray truncate">
                      {r.rental_id} · {r.equipment_associations?.length ?? 0} Items
                      {r.location ? ` · ${r.location.name}` : ""}
                      {r.start_date ? ` · ${new Date(r.start_date).toLocaleDateString("de-DE")}` : ""}
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
